'use client';
import Logo from './Logo';
import Link from '../ui/Link';
import List from '../ui/List';
import Line from './Line';

const Footer = () => {
    return (
        <footer className="w-full bg-background-secondary">
            <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[60px] py-8 sm:py-10 lg:py-[30px]">
                {/* Main Footer Content */}
                <div className="flex flex-col lg:flex-row justify-between items-start gap-8 lg:gap-12 mt-8 sm:mt-10 lg:mt-[42px]">
                    {/* Brand Section */}
                    <div className="flex flex-col gap-8 sm:gap-10 lg:gap-[50px] w-full lg:w-1/4">
                        <div className="flex flex-col gap-6 sm:gap-8 lg:gap-[36px]">
                            <Logo
                                src="/images/img_footer_logo.png"
                                alt="NEHDO Wellness Footer Logo"
                                width={280}
                                height={98}
                                className="w-[200px] sm:w-[240px] lg:w-[280px]"
                            />
                            <p className="text-lg sm:text-xl lg:text-xl text-text-opacity-60 font-normal leading-6 sm:leading-7 lg:leading-7xl">
                                We have clothes that suits your style and which you are proud to wear. From women to men.
                            </p>
                        </div>

                        {/* Social Icons */}
                        <div className="flex flex-row gap-3 sm:gap-4 lg:gap-[16px]">
                            <Link href="https://twitter.com" external ariaLabel="Twitter">
                                <img src="/images/img_1.svg" alt="Twitter" className="w-8 h-8 sm:w-9 sm:h-9 lg:w-[40px] lg:h-[40px]" />
                            </Link>
                            <Link href="https://facebook.com" external ariaLabel="Facebook">
                                <img src="/images/img_2.svg" alt="Facebook" className="w-8 h-8 sm:w-9 sm:h-9 lg:w-[40px] lg:h-[40px]" />
                            </Link>
                            <Link href="https://instagram.com" external ariaLabel="Instagram">
                                <img src="/images/img_3.svg" alt="Instagram" className="w-8 h-8 sm:w-9 sm:h-9 lg:w-[40px] lg:h-[40px]" />
                            </Link>
                            <Link href="https://github.com" external ariaLabel="GitHub">
                                <img src="/images/img_4.svg" alt="GitHub" className="w-8 h-8 sm:w-9 sm:h-9 lg:w-[40px] lg:h-[40px]" />
                            </Link>
                        </div>
                    </div>

                    {/* Footer Links Grid */}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 lg:gap-12 w-full lg:w-3/4">
                        {/* Company */}
                        <div className="flex flex-col gap-6 sm:gap-7 lg:gap-[34px]">
                            <h3 className="text-lg sm:text-xl lg:text-3xl text-text-primary font-semibold leading-5 sm:leading-6 lg:leading-4xl uppercase tracking-[4px]">
                                Company
                            </h3>
                            <List className="flex flex-col gap-3 sm:gap-3 lg:gap-[16px]">
                                <li>
                                    <Link href="/about" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="About">
                                        About
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/features" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="Features">
                                        Features
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/works" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="Works">
                                        Works
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/career" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="Career">
                                        Career
                                    </Link>
                                </li>
                            </List>
                        </div>

                        {/* Help */}
                        <div className="flex flex-col gap-6 sm:gap-7 lg:gap-[34px]">
                            <h3 className="text-lg sm:text-xl lg:text-3xl text-text-primary font-semibold leading-5 sm:leading-6 lg:leading-4xl uppercase tracking-[4px]">
                                Help
                            </h3>
                            <List className="flex flex-col gap-3 sm:gap-3 lg:gap-[16px]">
                                <li>
                                    <Link href="/support" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-normal leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" style={{ fontFamily: 'Poppins' }} ariaLabel="Customer Support">
                                        Customer Support
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/delivery" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-normal leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" style={{ fontFamily: 'Poppins' }} ariaLabel="Delivery Details">
                                        Delivery Details
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/terms" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-normal leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" style={{ fontFamily: 'Poppins' }} ariaLabel="Terms & Conditions">
                                        Terms & Conditions
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/privacy" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-normal leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" style={{ fontFamily: 'Poppins' }} ariaLabel="Privacy Policy">
                                        Privacy Policy
                                    </Link>
                                </li>
                            </List>
                        </div>

                        {/* FAQ */}
                        <div className="flex flex-col gap-6 sm:gap-7 lg:gap-[34px]">
                            <h3 className="text-lg sm:text-xl lg:text-3xl text-text-primary font-semibold leading-5 sm:leading-6 lg:leading-4xl uppercase tracking-[4px]">
                                FAQ
                            </h3>
                            <List className="flex flex-col gap-3 sm:gap-3 lg:gap-[16px]">
                                <li>
                                    <Link href="/account" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="Account">
                                        Account
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/manage-deliveries" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="Manage Deliveries">
                                        Manage Deliveries
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/orders" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="Orders">
                                        Orders
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/payments" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="Payments">
                                        Payments
                                    </Link>
                                </li>
                            </List>
                        </div>

                        {/* Resources */}
                        <div className="flex flex-col gap-6 sm:gap-7 lg:gap-[34px]">
                            <h3 className="text-lg sm:text-xl lg:text-3xl text-text-primary font-semibold leading-5 sm:leading-6 lg:leading-4xl uppercase tracking-[4px]">
                                Resources
                            </h3>
                            <List className="flex flex-col gap-3 sm:gap-3 lg:gap-[16px]">
                                <li>
                                    <Link href="/ebooks" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="Free eBooks">
                                        Free eBooks
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/tutorial" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="Development Tutorial">
                                        Development Tutorial
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/blog" className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="How to - Blog">
                                        How to - Blog
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/youtube" external className="text-lg sm:text-xl lg:text-3xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-3xl hover:text-primary-brand" ariaLabel="Youtube Playlist">
                                        Youtube Playlist
                                    </Link>
                                </li>
                            </List>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="flex flex-col gap-4 sm:gap-5 lg:gap-[26px] mt-8 sm:mt-10 lg:mt-12">
                    <Line className="w-full" />

                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-6">
                        <p className="text-base sm:text-lg lg:text-xl text-text-opacity-60 font-medium leading-5 sm:leading-6 lg:leading-xl text-center sm:text-left">
                            Shop.co © 2016-2026, All Rights Reserved
                        </p>

                        {/* Payment Methods */}
                        <div className="flex flex-row flex-wrap justify-center sm:justify-end items-center gap-3 sm:gap-3 lg:gap-[16px]">
                            <div className="bg-background-main rounded-md shadow-[0px_1px_6px_#b7b7b714] p-2 sm:p-2.5 lg:p-[12px]">
                                <img src="/images/img_visa.svg" alt="Visa" className="w-[36px] sm:w-[42px] lg:w-[46px] h-auto" />
                            </div>
                            <div className="bg-background-main rounded-md shadow-[0px_1px_6px_#b7b7b714] p-2 sm:p-2 lg:p-[10px]">
                                <img src="/images/img_mastercard.svg" alt="Mastercard" className="w-[30px] sm:w-[33px] lg:w-[36px] h-auto" />
                            </div>
                            <div className="bg-background-main rounded-md shadow-[0px_1px_6px_#b7b7b714] p-2 sm:p-2.5 lg:p-[14px]">
                                <img src="/images/img_paypal.svg" alt="PayPal" className="w-[42px] sm:w-[46px] lg:w-[50px] h-auto" />
                            </div>
                            <div className="bg-background-main rounded-md shadow-[0px_1px_6px_#b7b7b714] p-2 sm:p-2.5 lg:p-[12px]">
                                <img src="/images/img_pay.svg" alt="Apple Pay" className="w-[32px] sm:w-[35px] lg:w-[38px] h-auto" />
                            </div>
                            <div className="bg-background-main rounded-md shadow-[0px_1px_6px_#b7b7b714] p-2 sm:p-2.5 lg:p-[12px]">
                                <img src="/images/img_g_pay.svg" alt="Google Pay" className="w-[34px] sm:w-[37px] lg:w-[40px] h-auto" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer